module.exports = __webpack_public_path__ + "static/media/fox.73abaca0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/fox.svg
// module id = 618
// module chunks = 6